import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";

export default class Debriefing {
    constructor() {
        this.elms = {
            submitDebrief: "#submitDebrief",
            finishDebrief: "#finishDebrief",
            form: ".js-debriefing-form",
            debriefingItems: ".debriefing__content",
            nextDebrief: ".next-debrief-btn",
            backDebrief: ".back-debrief-btn",
            questionItem: ".debriefing__item",
            questionWrapper: ".question",
            debriefItem: ".debriefing__item",
        };

        this.slickOpts = {
            arrows: false,
            swipe: false,
            centerMode: true,
            dots: false,
            loops: false,
            infinite: false,
        };

        this.isLoading = false;
        return this;
    }
    setQuestionSlider() {
        var slider = $(".js-question-slider");
        slider.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $(".js-question-prev"),
            nextArrow: $(".js-question-next"),
            customPaging: function(slider, i) {
                // eslint-disable-next-line no-unused-vars
                var thumb = $(slider.$slides[i]).data(); // Ensure data attributes are defined in the slides
                return '<a>' + '</a>';
            }
        });

        slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".js-question-prev").prop('disabled', nextSlide === 0);
        $(".js-question-next").prop('disabled', nextSlide === slick.slideCount - 1);
        });
    }

    init() {
        bdjs.hideLoading();
        const elms = this.elms;

        // @ts-ignore
        $(elms.debriefingItems).slick(this.slickOpts);
        $(elms.backDebrief).on("click", this._goToPreviousItem.bind(this));
        $(elms.finishDebrief).on("click", this._onFormSubmited.bind(this));

        $(".app__brand").find(".invert").css("display","block");
        $(".app__brand").find(".normal").css("display","none");


        $(elms.form).on(
            "change",
            'input[type="radio"]',
            this._removeErrorState,
        );
        $(elms.form).on(
            "input",
            [$("#txtArea").val(), 'input[type="email"]'].join(","),
            this._removeErrorState,
        );

        this.setQuestionSlider();
    }

    _finishDebriefing() {
        if (this.isLoading) return;

        setTimeout(function(){
            $(".resultPage").removeClass("is-debriefing");
        }, 700)
    }

    _removeErrorState(e) {
        const $el = $(e.currentTarget);
        const $questionAnswer = $el.parents(".question").first();

        $questionAnswer.removeClass(["has-error", "has-validation-error"]);
    }

    _goToPreviousItem() {
        $(this.elms.debriefingItems).slick("slickPrev");
    }

    _onFormSubmited(e) {
        // prettier-ignore
        // eslint-disable-next-line
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $questionItems = $('.debriefing__item'); 
        const $wrapper = $this.find(elms.questionWrapper);
        const slick = $(elms.debriefingItems).slick("getSlick");
        const isLastSlide = slick.currentSlide === slick.slideCount - 1;
        const sanitize = (input) => {
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#x27;',
                "/": '&#x2F;',
            };
            const reg = /[&<>"'/]/ig;
            return input.replace(reg, (match)=>(map[match]));
        };
            
        let isAnswered = true;

        $questionItems.each(function () {
            const $questionItem = $(this);
            let answer = "";
            let questionType = $questionItem.data('type-question'); 
            
            if (questionType !== "finish_button" && questionType !== "plain_text_image") {
                if (questionType === "input_text") {
                    answer = sanitize(String($questionItem.find("textarea#txtArea").val())) || "";
                } else if (questionType === "multiple_choices") {
                    answer = String($questionItem.find("input[type=radio]:checked").val()) || "";
                }

                if ( !answer || answer.trim() === "" || answer === "undefined") {
                        isAnswered = false;
                        alert("Please fill out all required fields.");
                        return false; 
                } else if (questionType === "email") {
                    const isValidEmail = emailRegex.test(answer);
                    $questionItem.toggleClass("has-validation-error", !isValidEmail);
                    isAnswered = isAnswered && isValidEmail;
                }
            }
        });

        if (isAnswered === true) {
            $wrapper.removeClass(["has-error", "has-validation-error"]);

            if (isLastSlide) {
                $(elms.finishDebrief).prop("disabled", true);
                this._submitDebriefing();
            } else {
                $(elms.debriefingItems).slick("slickNext");
            }
        }
        return false;
    }

    async _submitDebriefing() {
        const elms = this.elms;
        const $submitBtn = $('button[type="submit"]');
        $(elms.finishDebrief).prop("disabled", true);
        $(elms.debriefItem).find("input").prop("readonly", true);
        if (this.isLoading) return;

        $submitBtn.addClass("is-loading");
        this.isLoading = true;

        const $questions = $(elms.questionItem);
        const answers = [];

        const sanitize = (input) => {
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#x27;',
                "/": '&#x2F;',
            };
            const reg = /[&<>"'/]/ig;
            return input.replace(reg, (match)=>(map[match]));
        };

        $.each($questions, function (index, question) {
            const $question = $(question);
            const questionID = $question.attr("data-id");
            const questionType = $question.data('type-question'); 
            const answerText = sanitize($question
                .find("textarea#txtArea, input[type=email]")
                .val() || "");
            const answerChoice = $question
                .find("input[type=radio]:checked")
                .val();

            if (questionType !== "plain_text" || questionType !== "plain_text_with_image" ) {
                answers.push({
                    question_id: questionID,
                    answer: answerText || answerChoice,
                });
            }
        });
        
        $(elms.debriefItem)
            .find("textarea#txtArea, input[type='email']")
            .val("");

        $(elms.debriefingItems).slick("slickGoTo", 0);

        const [res] = await bdjs.goAsync(
            bdapi.post("game/submit-debriefing", {
                answers: answers,
            }),
        );

        const resData = res?.data || {};

        if (resData?.success) {
            $submitBtn.prop("disabled", true);
            setTimeout(function(){
                $(".resultPage").removeClass("is-debriefing");
            }, 700)

            const [result] = await bdjs.goAsync(bdapi.post("game/restart-game"));
            const resultData = result?.data || {};

            if (resultData?.data?.redirect) {
                bdjs.showLoading();
                $(".transitionPage").show();
                setTimeout(
                    () => window.location.replace(resultData.data.redirect),
                    1000,
                );
                return;
            }
        }
        

        return false;
    }
}
